import * as React from 'react';
import AvailabilityTabs from './AvailabilityTabs/AvailabilityTabs';
import BedroomTabs from './BedroomTabs/BedroomTabs';
import LocationTabs from './LocationTabs/LocationTabs';
import PCMSlider from './PCMSlider/PCMSlider';
import S from './Search.styles';
import { handleParamChange } from '@core/utils';
const DEFAULT_FORM_STATE = {
    location: [],
    bedrooms: [],
    availability: '',
    pcm: 5000,
};
const Search = ({ title, form, action, submitButtonText, clearAllButtonText, }) => {
    const activeLocations = form.location.options
        .filter((option) => option.active)
        .map((option) => option.value);
    const [activeLocation, setActiveLocation] = React.useState(activeLocations);
    const activeBedrooms = form.bedrooms.options
        .filter((option) => option.active)
        .map((option) => option.value);
    const [activeBedroom, setActiveBedroom] = React.useState(activeBedrooms);
    const activeAvailability = form.availability.options
        .filter((option) => option.active)
        .map((option) => option.value);
    const [availability, setAvailability] = React.useState(activeAvailability?.[0] || '');
    const [pcm, setPcm] = React.useState(5000);
    const clearState = () => {
        setActiveLocation(DEFAULT_FORM_STATE.location);
        setActiveBedroom(DEFAULT_FORM_STATE.bedrooms);
        setPcm(DEFAULT_FORM_STATE.pcm);
        setAvailability(DEFAULT_FORM_STATE.availability);
    };
    //TODO:: Adjust this to check all options
    const isDirty = activeLocation.length > 0 || activeBedroom.length > 0 || (availability != form.availability.options.map((option) => option.value)?.[0] && availability != DEFAULT_FORM_STATE.availability) || pcm != 5000;
    return (React.createElement(S.Bg, null,
        React.createElement(S.Container, null,
            React.createElement(S.Title, { dangerouslySetInnerHTML: { __html: title } }),
            React.createElement(S.Form, { method: "GET", onSubmit: (e) => {
                    e.preventDefault();
                    const qs = new URLSearchParams();
                    const locationParams = handleParamChange('locations', activeLocation);
                    const bedroomParams = handleParamChange('bedrooms', activeBedroom);
                    const availabilityParams = handleParamChange('availability', availability);
                    const pcmParams = handleParamChange('pcm', pcm);
                    [locationParams, bedroomParams, availabilityParams, pcmParams].forEach((params) => {
                        params.forEach((value, key) => {
                            if (value)
                                qs.append(key, value);
                        });
                    });
                    window.location.href = `${action}?${new URLSearchParams(qs.toString()).toString()}`;
                } },
                React.createElement(S.FormLocation, null,
                    React.createElement(LocationTabs, { activeIds: activeLocation, onLocationChange: setActiveLocation, options: form.location })),
                React.createElement(S.FormBedroom, null,
                    React.createElement(BedroomTabs, { activeIds: activeBedroom, onBedroomChange: setActiveBedroom, options: form.bedrooms })),
                React.createElement(S.FormAvailability, null,
                    React.createElement(AvailabilityTabs, { options: form.availability, activeId: availability, onAvailabilityChange: setAvailability })),
                React.createElement(S.FormPCM, null,
                    React.createElement(PCMSlider, { activeLocation: activeLocation, locationOptions: form.location.options, onUpdate: setPcm, startValue: pcm })),
                isDirty && (React.createElement(S.ClearAllButton, { type: "button", onClick: clearState }, clearAllButtonText)),
                React.createElement(S.SubmitButton, { type: "submit", noIcon: true }, isDirty ? submitButtonText.selectedText : submitButtonText.unselectedText)))));
};
export default Search;
